import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2b2c0d82&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=2b2c0d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c0d82",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer})
